import { render, staticRenderFns } from "./index.vue?vue&type=template&id=116e1f8f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=116e1f8f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116e1f8f')) {
      api.createRecord('116e1f8f', component.options)
    } else {
      api.reload('116e1f8f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=116e1f8f", function () {
      api.rerender('116e1f8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dental/index.vue"
export default component.exports